<template>
  <div class="income" v-loading="loading">
    <div class="income-first">
      <div class="income-first-view">
        <div class="income-first-list">
          <div class="first-list-block" v-for="(item, index) in 5" :key="index">
            <div class="list-block-title">
              {{
                index == 0
                  ? '用户id'
                  : index == 1
                  ? '合伙人名称'
                  : index == 2
                  ? '合伙人手机号'
                  : index == 3
                  ? 'id状态'
                  : index == 4
                  ? '创建时间'
                  : ''
              }}
            </div>
            <div class="list-block-input">
              <el-input
                v-if="index == 0"
                v-model="partnerId"
                clearable
                placeholder="请输入用户id"
              ></el-input>

              <el-input
                v-if="index == 1"
                v-model="partnerName"
                clearable
                placeholder="请输入合伙人名称"
              ></el-input>

              <el-input
                v-if="index == 2"
                v-model="partnerPhone"
                clearable
                placeholder="请输入合伙人手机号"
              ></el-input>

              <el-select
                v-if="index == 3"
                v-model="partnerIdstatus"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in partnerIdOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>

              <el-date-picker
                v-if="index == 4"
                value-format="yyyy-MM-dd"
                v-model="partnerPaymentTime"
                type="daterange"
                range-separator
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
          </div>
        </div>

        <div class="income-first-button">
          <div class="income-first-button-left" @click="incomeInquire">
            查询
          </div>
          <div class="income-first-button-right" @click="incomeReset">重置</div>
        </div>
      </div>
    </div>

    <div class="income-second">
      <div class="income-second-div">
        <div class="income-second-div-left">合伙人人数：{{ totalNum }}人</div>
        <div class="income-second-div-right">
          <div class="income-second-div-right-refresh" @click="refreshClick">
            刷新
          </div>
          <div class="income-second-div-right-derive" @click="deriveClick">
            <img
              class="income-second-div-right-derive-img"
              src="../../assets/common/common-derive.png"
            />
            <div class="income-second-div-right-derive-text">导出订单</div>
          </div>
        </div>
      </div>

      <div class="income-second-table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border=""
          @selection-change="handleSelectionChange"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="userId" label="用户id" width="100">
          </el-table-column>
          <el-table-column prop="id" label="合伙人ID" width="100">
          </el-table-column>
          <el-table-column prop="realname" label="合伙人姓名" width="150">
          </el-table-column>
          <el-table-column prop="userPhone" label="合伙人手机号" width="150">
          </el-table-column>
          <el-table-column label="合伙人类型" width="150">
            <template slot-scope="scope">
              {{
                scope.row.collaborateId == 0
                  ? '不满足合伙人条件'
                  : scope.row.collaborateId == 1
                  ? '初级合伙人'
                  : scope.row.collaborateId == 2
                  ? '精英合伙人'
                  : scope.row.collaborateId == 3
                  ? '事业合伙人'
                  : ''
              }}
            </template>
          </el-table-column>

          <el-table-column
            prop="grandPrice"
            label="合伙人团队订单总收益"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="lockPrice"
            label="合伙人团队订单收益(锁定中收益)"
            width="210"
          >
          </el-table-column>
          <el-table-column
            prop="consumePrice"
            label="合伙人团队订单可提现收益"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="withdrawPrice"
            label="合伙人团队订单已提现收益"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="accumulatedSubsidies"
            label="合伙人累计补贴"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="accumulatedDifferentialInterestSubsidy"
            label="合伙人累计差额息补贴"
            width="240"
          >
          </el-table-column>
          <el-table-column label="操作" width="280" fixed="right">
            <template slot-scope="scope">
              <div class="table-operation">
                <div
                  class="table-operation-left"
                  @click="orderMet(scope.row, 0)"
                >
                  订单明细
                </div>
                <div
                  class="table-operation-left"
                  @click="orderMet(scope.row, 1)"
                >
                  收益明细
                </div>
                <div
                  class="table-operation-left"
                  @click="orderMet(scope.row, 2)"
                >
                  提现明细
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="income-second-Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>

    <!--第二区域  进行禁用-->
    <div class="examine">
      <el-dialog
        :visible.sync="examineDialogVisible"
        style="margin-top: 10vh"
        @close="examineCancel"
      >
        <span slot="footer" class="dialog-footer">
          <div class="examine-password">
            <div class="password">
              <img
                class="password-img"
                src="../../assets/common/common-warning.png"
              />
            </div>

            <div class="title">
              是否确定将该合伙人id{{
                examineObj.status == -1 ? '启动？' : '禁用？'
              }}
            </div>
            <div class="text">
              一旦确定将进行{{ examineObj.status == -1 ? '启动' : '禁用' }}
            </div>
          </div>

          <div class="examine-button">
            <div class="examine-button-left" @click="examineConfirm">确定</div>
            <div class="examine-button-right" @click="examineCancel">取消</div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--第二区域 查看银行卡-->
    <div class="bank">
      <el-dialog
        :visible.sync="bankDialogVisible"
        style="margin-top: 10vh"
        @close="bankCancel"
      >
        <span slot="footer" class="dialog-footer">
          <div class="bank-title">
            <div class="title">合伙人银行卡卡号</div>
            <img
              @click="bankCancel"
              class="img"
              src="../../assets/common/close.png"
              alt=""
            />
          </div>

          <div class="bank-display" v-if="bankList.length > 0">
            <div
              class="bank-block"
              v-for="(item, index) in bankList"
              :key="index"
            >
              <div class="block">
                <div class="bank-block-title">
                  <div class="title">{{ bank_name }}</div>
                  <div class="text">{{ item.phone }}</div>
                </div>
                <div class="bank-block-span">{{ item.bank_number }}</div>
              </div>
            </div>
          </div>

          <div class="bank-emty" v-else>暂无数据</div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getcollaborateStaticInfo,
  getbankInfo,
  postupdateCollaborate,
} from '../../api/partenr'

import Bus from '../../utils/bus'
export default {
  data() {
    return {
      // 第一区域
      partnerId: '',
      partnerName: '',
      partnerPhone: '',
      // 用户id状态
      partnerIdstatus: '1',
      partnerIdOptions: [
        {
          value: '-2',
          label: '待审核',
        },
        {
          value: '-1',
          label: '禁止',
        },
        {
          value: '0',
          label: '失效',
        },
        {
          value: '1',
          label: '生效',
        },
      ],
      partnerPaymentTime: [],
      partnerPaymentTimeA: '',
      partnerPaymentTimeB: '',
      // 第二区域 表格数组
      tableData: [],
      // 第二区域 表格总条数
      totalNum: 0,
      // 存储表格选中的值
      multipleSelection: [],
      // 页码
      page: 1,
      // 页数
      limit: 10,
      // 监听用户刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      incomeFunShow: false,
      // 触发
      examineObj: {},
      examineDialogVisible: false,
      //
      bankDialogVisible: false,
      bankObj: {},
      bankList: [],
      bankTotal: 0,
    }
  },
  created() {
    this.loading = true
    this.getcollaborateStaticInfoMet()
    setTimeout(() => {
      this.incomeFunShow = this.$store.state.pageFunctionShow
    }, 1000)
  },
  methods: {
    getcollaborateStaticInfoMet() {
      let params = {
        userId: this.partnerId,
        realname: this.partnerName,
        userPhone: this.partnerPhone,
        createStartTime: this.partnerPaymentTimeA,
        createEndTime: this.partnerPaymentTimeB,
        status: this.partnerIdstatus,
        type: '',
        withdrawStatus: '',
        orderId: '',
        orderDetailId: '',
        pageNo: this.page,
        pageSize: this.limit,
      }

      getcollaborateStaticInfo(params).then((res) => {
        if (res.resultStatus == true) {
          console.log('获取列表数据', res)
          // 获取表格数组
          this.tableData = res.resultData.collaborateList
          // 获取总数
          this.totalNum = res.resultData.totalNum
          this.loading = false
        }
      })
    },
    // 第一区域查询
    incomeInquire() {
      // 订单支付时间
      if (
        this.partnerPaymentTime != null &&
        this.partnerPaymentTime.length != 0
      ) {
        this.partnerPaymentTimeA = this.partnerPaymentTime[0]
        this.partnerPaymentTimeB = this.partnerPaymentTime[1]
      } else {
        this.partnerPaymentTimeA = ''
        this.partnerPaymentTimeB = ''
      }

      this.getcollaborateStaticInfoMet()
    },
    // 第一区域重置
    incomeReset() {
      this.loading = true
      this.partnerId = ''
      this.partnerName = ''
      this.partnerPhone = ''
      this.partnerIdstatus = ''
      this.partnerPaymentTimeA = ''
      this.partnerPaymentTimeB = ''
      this.page = 1

      this.$nextTick(() => {
        this.getcollaborateStaticInfoMet()
      })
    },

    // 表格区域
    // 刷新当前订单
    refreshClick() {
      this.loading = true
      this.getcollaborateStaticInfoMet()
    },
    // 导出订单
    deriveClick() {
      if (this.incomeFunShow == false) {
        this.$message.error('暂无权限！')
        return
      }
      // if (this.marketFunShow == true) {
      //     let commodityIds = this.multipleSelection
      //         .map((item) => {
      //             return item.id
      //         })
      //         .join(';')

      //     let Url =
      //         'https://laravel-api-manager.xmw1688.com/v1/manager/order?excel=' +
      //         1 +
      //         '&ids=' +
      //         commodityIds +
      //         '&userId' +
      //         this.marketUserid +
      //         '&userName=' +
      //         this.marketUsername +
      //         '&userPhone=' +
      //         this.marketUserphone +
      //         '&name=' +
      //         this.marketRecipients +
      //         '&wuliu_num=' +
      //         this.marketLogistics +
      //         '&phone=' +
      //         this.marketRecipientsphone +
      //         '&supplierName=' +
      //         this.marketSuppliername +
      //         '&address=' +
      //         this.marketTake +
      //         '&ordernum=' +
      //         this.marketOrdernum +
      //         '&status=' +
      //         this.marketOrderstatusType +
      //         '&paytype=' +
      //         this.marketPaymentType +
      //         '&createStartTime=' +
      //         this.marketEstablishtimeA +
      //         '&createEndTime=' +
      //         this.marketEstablishtimeB +
      //         '&payStartTime=' +
      //         this.marketPaymentTimeA +
      //         '&payEndTime=' +
      //         this.marketPaymentTimeB +
      //         '&shouStartTime=' +
      //         this.marketOrdertakeA +
      //         '&shouEndTime=' +
      //         this.marketOrdertakeB +
      //         '&paycode=' +
      //         this.marketPaymentNum +
      //         '&activityStatus=' +
      //         this.marketOrderType +
      //         '&accessToken=' +
      //         localStorage.getItem('token')

      //     window.location.href = Url

      //     console.log('查看参数', Url)

      //     this.loading = false
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 点击禁用
    forbiddenBtn(item) {
      if (this.incomeFunShow == false) {
        this.$message.error('暂无权限！')
        return
      }

      this.examineObj = item
      this.examineDialogVisible = true
    },

    examineConfirm() {
      let params = {
        userId: this.examineObj.userId,
        status: this.examineObj.status == -1 ? 1 : -1,
      }
      postupdateCollaborate(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: this.examineObj.status == -1 ? '启动成功！' : '禁用成功！',
            type: 'success',
          })
          this.getcollaborateStaticInfoMet()
          this.examineDialogVisible = false
        }
      })
    },
    examineCancel() {
      this.examineDialogVisible = false
    },

    bankBtn(item) {
      if (this.incomeFunShow == false) {
        this.$message.error('暂无权限！')
        return
      }

      this.bankObj = item

      let params = {
        userId: item.userId,
        pageSize: 100,
        pageNo: 1,
        status: 0,
        createEndTime: '',
        createStartTime: '',
        nickname: '',
        phone: '',
      }

      getbankInfo(params).then((res) => {
        if (res.resultStatus == true) {
          this.bankList = res.resultData.list
          this.bankTotal = res.resultData.totalNum
        }
      })

      this.bankDialogVisible = true
    },

    bankCancel() {
      this.bankDialogVisible = false
    },

    //-----------------
    orderMet(item, index) {
      if (this.incomeFunShow == false) {
        this.$message.error('暂无权限！')
        return
      }

      if (index == 0) {
        Bus.$emit('log', 'partenrIncomeOrder', item)
      } else if (index == 1) {
        Bus.$emit('log', 'partenrIncomeEarnings', item)
      } else {
        Bus.$emit('log', 'partenrIncomeDeposit', item)
      }
    },
    //  查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      this.getcollaborateStaticInfoMet()
    },
    //  查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      this.getcollaborateStaticInfoMet()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

/deep/ .el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
  border-color: #dcdfe6;
}

.income {
  .income-first {
    width: 100%;
    height: 180px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px;
    display: flex;
    align-items: center;

    .income-first-view {
      .income-first-list {
        display: flex;

        .first-list-block {
          width: 180px;
          margin-right: 25px;

          .list-block-title {
            height: 17px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 17px;
            margin-bottom: 4px;
          }

          .list-block-input {
            width: 180px;
            height: 32px;
            background: #ffffff;
            border-radius: 5px;

            /deep/ .el-input {
              width: 180px;
              height: 32px;
            }

            /deep/ .el-input__inner {
              padding: 0 10px;
              box-sizing: border-box;
              height: 32px;
              background-color: rgba(255, 255, 255, 0);
            }

            /deep/ .el-input__inner::-webkit-input-placeholder {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #cacaca;
              line-height: 32px;
            }

            /deep/ .el-select .el-input.is-focus .el-input__inner {
              border-color: rgba(217, 217, 217, 1);
            }
          }
        }
      }

      .income-first-button {
        width: 100%;
        height: 36px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        margin-top: 27px;

        .income-first-button-left,
        .income-first-button-right {
          text-align: center;
          width: 110px;
          height: 36px;
          background: #222222;
          border-radius: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 36px;
          cursor: pointer;
        }

        .income-first-button-right {
          background: #f4f5f9;
          color: #999999;
          margin-left: 10px;
        }
      }
    }
  }

  .income-second {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    margin-top: 24px;
    padding: 24px;
    box-sizing: border-box;

    .income-second-div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;

      .income-second-div-left {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .income-second-div-right {
        display: flex;
        align-items: center;
        justify-content: center;

        .income-second-div-right-refresh {
          width: 70px;
          height: 36px;
          border-radius: 10px;
          border: 1px solid rgba(34, 34, 34, 0.4);
          text-align: center;
          line-height: 36px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222222;
          cursor: pointer;
        }

        .income-second-div-right-derive {
          width: 110px;
          height: 36px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          margin-left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .income-second-div-right-derive-img {
            width: 12px;
            height: 12px;
          }

          .income-second-div-right-derive-text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            margin-left: 8px;
          }
        }
      }
    }

    .income-second-table {
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table td.el-table__cell div {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      /deep/ .el-table__cell {
        vertical-align: top;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;

        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }

      .table-operation {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;

        .table-operation-left {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
          cursor: pointer;
          margin-right: 20px;
        }
      }
    }

    .income-second-Pagination {
      height: 88px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }

  .examine {
    /deep/ .el-dialog {
      height: 231px;
      width: 394px;
    }

    /deep/ .el-dialog__footer {
      padding: 25px 0;
      box-sizing: border-box;
    }

    .examine-password {
      width: 100%;

      .password {
        display: flex;

        .password-img {
          width: 56px;
          height: 56px;
          margin: 0 auto;
        }
      }

      .title {
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        margin: 15px 0 5px;
        text-align: center;
      }

      .text {
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        text-align: center;
      }
    }

    .examine-button {
      display: flex;
      justify-content: center;
      align-content: center;
      margin-top: 30px;

      .examine-button-left,
      .examine-button-right {
        width: 88px;
        height: 32px;
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        border-radius: 10px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }

      .examine-button-right {
        margin-left: 8px;
        border: 1px solid #e9edf4;
        color: rgba(0, 0, 0, 0.65);
        background: #ffffff;
      }
    }
  }

  .bank {
    /deep/ .el-dialog {
      width: 744px;
      height: 420px;
      overflow: auto;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      box-sizing: border-box;
    }

    .bank-title {
      height: 56px;
      width: 100%;
      border-bottom: 1px solid #999;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      box-sizing: border-box;

      .title {
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .img {
        width: 11px;
        height: 10px;
        cursor: pointer;
      }
    }

    .bank-display {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 0 60px;
      box-sizing: border-box;

      .bank-block {
        width: 40%;
        margin-top: 20px;
        text-align: left;
        padding: 0 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        .block {
          .bank-block-title {
            display: flex;

            .title,
            .text {
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              color: #999999;
            }

            .text {
              margin-left: 20px;
            }
          }

          .bank-block-span {
            font-size: 16px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #222222;
            margin-top: 5px;
          }
        }
      }
    }

    .bank-emty {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #999999;
      text-align: center;
      margin-top: 140px;
    }
  }
}
</style>
